import { httpSingleton } from '@/lib/http-client';
import { ActionTrackingRequest } from '@/lib/models';

export const trackingService = {
	track(data: ActionTrackingRequest) {
		return httpSingleton.orchestrateRequest<void>({
			method: 'POST',
			url: `/auth-service/api/v1/public/tracking`,
			data,
		});
	},
};
